import { render } from "./RegionsMap.vue?vue&type=template&id=7b113077&scoped=true"
import script from "./RegionsMap.vue?vue&type=script&lang=js"
export * from "./RegionsMap.vue?vue&type=script&lang=js"

import "./RegionsMap.vue?vue&type=style&index=0&id=7b113077&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7b113077"

export default script